import { z } from "zod";

export const months = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
] as const;

export const monthsEnum = z.enum(months);
export type MonthType = z.infer<typeof monthsEnum>;
